// extracted by mini-css-extract-plugin
export default {"Container":"Header_Container__QCm00","skipWrapper":"Header_skipWrapper__sEoSF"};